type StoreSizeFilter = {
  translationKey: string
  value: string
}

export const storeSizeFilters: Array<StoreSizeFilter> = [
  {
    translationKey: 'text_largestore',
    value: 'largeStore',
  },
  {
    translationKey: 'text_megastore',
    value: 'extraLargeStore',
  },
  {
    translationKey: 'text_all',
    value: '',
  },
]

export const filterTranslationMap: { [index: string]: string } = {
  men: 'text_carry_men',
  baby: 'text_carrybaby',
  kids: 'text_carrykids',
  maternity: 'text_carrymaternity',
  women: 'text_carry_women',
  parking: 'text_parkinglot_available',
  wheelchairAccessibleParking: 'text_store_locator_accessible_parking_lot',
  teen: 'text_carry_teen',
  openFrontInner: 'text_carry_open_front_inner',
  uniqloFlower: 'text_uniqlo_flower',
  utMe: 'text_ut_me',
  reUniqloStudio: 'text_re_uniqlo_studio',
  customOrderMen: 'text_custom_order_men',
  customOrderWomen: 'text_custom_order_women',
}
